import { useParams } from "@tanstack/react-router";
import { useLatestVersionNumber } from "./useVersionInformation";

/**
 * Returns the version number from the URL params. You typically want to use
 * `useActiveVersionNumber` to get the actual version number (which also relies
 * on information from the store).
 */
export function useParamVersionNumber() {
  return useParams({
    strict: false,
    select: (params) => params.versionNumber,
  });
}

/**
 * Returns the active version number. This is the version number that is
 * currently being displayed in the UI. It is derived from the URL params, and
 * falls back to the latest version number if the URL params are not set.
 */
export function useActiveVersionNumber(): number {
  const versionNumberString = useParamVersionNumber();

  const latestVersion = useLatestVersionNumber();

  const cleanVersionNumber = versionNumberString?.replace(/^v/, "");
  const versionNumber = cleanVersionNumber
    ? Number.parseInt(cleanVersionNumber, 10)
    : Number.NaN;

  return Number.isNaN(versionNumber) ? (latestVersion ?? 1) : versionNumber;
}
